import { defineStore } from 'pinia';
import { ref } from 'vue';

type BreadcrumbDynamicTitle = {
    id: string;
    name: string;
};

export const useBreadcrumbsStore = defineStore(
    'breadcrumbs',
    () => {
        const program = ref<BreadcrumbDynamicTitle | undefined>(undefined);
        const deliverable = ref<BreadcrumbDynamicTitle | undefined>(undefined);
        const projects = ref<BreadcrumbDynamicTitle[]>([]);

        function addProject(p: BreadcrumbDynamicTitle) {
            if (projects.value.length >= 2) {
                projects.value.shift();
            }

            if (!projects.value.some((project) => project.id === p.id)) {
                projects.value.push(p);
            }
        }

        function setProgram(p: BreadcrumbDynamicTitle) {
            program.value = p;
        }

        function setDeliverable(d: BreadcrumbDynamicTitle) {
            deliverable.value = d;
        }

        return {
            projects,
            program,
            deliverable,
            addProject,
            setProgram,
            setDeliverable,
        };
    },
    {
        persist: true,
    }
);
